/** 结果状态（Zustand）：批量结果 + 对比集，跨 BatchPage / ComparePage 共享。 */
import { create } from 'zustand';
import type { ExperimentResult } from '../data/export-csv';

interface ResultsState {
  lastBatch: ExperimentResult[];
  compare: ExperimentResult[];
  setLastBatch: (rows: ExperimentResult[]) => void;
  addToCompare: (rows: ExperimentResult[]) => void;
  removeFromCompare: (id: string) => void;
  clearCompare: () => void;
}

export const useResults = create<ResultsState>((set) => ({
  lastBatch: [],
  compare: [],
  setLastBatch: (rows) => set({ lastBatch: rows }),
  addToCompare: (rows) =>
    set((s) => {
      const existing = new Set(s.compare.map((r) => r.id));
      const merged = [...s.compare, ...rows.filter((r) => !existing.has(r.id))];
      return { compare: merged };
    }),
  removeFromCompare: (id) => set((s) => ({ compare: s.compare.filter((r) => r.id !== id) })),
  clearCompare: () => set({ compare: [] }),
}));
